import './polyfills';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { rememberSource } from './account/api';
import { AccountGate } from './account/AccountGate';
import { App } from './App';
import { watchForUpdates } from './app-version';
import { startCatalog } from './catalog';
import { startSpatialNavigation } from './spatial-navigation';
import { CatalogProvider } from './state/catalog-context';
import { withoutUnplayableUhd } from './uhd-access';
// Inter, shipped with the app (no font request to Google), so every device shows the same type.
import '@fontsource-variable/inter';
import './styles.css';

watchForUpdates();
// TV remotes: arrows move the focus, OK clicks, Back goes back.
startSpatialNavigation();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

// Which website button or ad brought this visitor (kept until they sign up, for the statistics).
rememberSource();

createRoot(root).render(
  <StrictMode>
    <CatalogProvider catalog={withoutUnplayableUhd(startCatalog())}>
      <AccountGate>
        <App />
      </AccountGate>
    </CatalogProvider>
  </StrictMode>,
);
